/**
Copyright (C) 2018 Andras Sarvari <andras.sarvari@sarvaria.net>

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted, provided that the above
copyright notice and this permission notice appear in all copies.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES
WITH REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF
MERCHANTABILITY AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR
ANY SPECIAL, DIRECT, INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES
WHATSOEVER RESULTING FROM LOSS OF USE, DATA OR PROFITS, WHETHER IN AN
ACTION OF CONTRACT, NEGLIGENCE OR OTHER TORTIOUS ACTION, ARISING OUT OF
OR IN CONNECTION WITH THE USE OR PERFORMANCE OF THIS SOFTWARE.
*/

/* jshint browser: true, esversion: 6, node:true */
/* globals console */

import React from 'react';
import Screen from '../Screen';
import Combobox from '../../Combobox/Combobox';
import Folderselector from '../../Folderselector/Folderselector';
import Checkbox from '../../Checkbox/Checkbox';
import Label from '../../Label/Label';
import Section from '../../Section/Section';
import Textbox from '../../Textbox/Textbox';
import Numericbox from '../../Numericbox/Numericbox';
import Button from '../../Button/Button';
import Dialog from '../../Dialog/Dialog';
import Snackbar from '../../Snackbar/Snackbar';
import Fab from '../../Fab/Fab';
import Service from '../../Util/Service';
import $ from '../../Util/Util';
import AddIcon from './baseline_add_white_24dp.png';
import DeleteIcon from './baseline_delete_black_24dp.png';
import './Importconfig.css';

/**
 * Represents the import configuration screen.
 */

export default class Import extends Screen {

    /**
     * Default state.
     */

    state = {
        configurations:         [],
        config:                 null,
        entitytype:             null,
        entitytypes:            [],
        attributes:             [],
        relations:              [],
        folder:                 null
    }

    _rename = () => {

        // Validating

        if (!this.state.folder) {
            $.fireEvent('snackbar', { message: this.props.context.locale.importconfig.missingfolder, error: true });
            return;
        }

        let empty = true;

        for (let i = 0; i < this.state.entitytype.attributes.length; i++) {
            if (!this['attr' + this.state.entitytype.attributes[i].id].isEmpty() && this['attr' + this.state.entitytype.attributes[i].id].getValue() !== 0) {
                empty = false;
                break;
            }
        }

        if (empty) {
            $.fireEvent('snackbar', { message: this.props.context.locale.importconfig.missingattribute, error: true });
            return;
        }

        let valid = true;

        for (let i = 0; i < this.state.entitytype.attributes.length; i++) {
            if (this['attr' + this.state.entitytype.attributes[i].id].getValue() === 0) {
                valid = false;
                break;
            }
        }

        if (!valid) {
            $.fireEvent('snackbar', { message: this.props.context.locale.importconfig.invalidattribute, error: true });
            return;
        }

        for (let i = 0; i < this.state.entitytype.attributes.length; i++) {
            for (let j = i + 1; j < this.state.entitytype.attributes.length; j++) {
                if (!this['attr' + this.state.entitytype.attributes[i].id].isEmpty() && this['attr' + this.state.entitytype.attributes[i].id].getValue() === this['attr' + this.state.entitytype.attributes[j].id].getValue()) {
                    valid = false;
                    break;
                }
            }
        }

        if (!valid) {
            $.fireEvent('snackbar', { message: this.props.context.locale.importconfig.duplicatecolumn, error: true });
            return;
        }

        valid = false;

        for (let i = 0; i < this.state.entitytype.attributes.length; i++) {
            if (!this['attr' + this.state.entitytype.attributes[i].id].isEmpty() && this.state.entitytype.attributes[i].id === this.primarykey.getItem().id) {
                valid = true;
                break;
            }
        }

        if (!valid) {
            $.fireEvent('snackbar', { message: this.props.context.locale.importconfig.missingprimarykey, error: true });
            return;
        }

        this.renameDialog.open().then(() => {
            this.configname.setValue(this.state.config.name);
            this.configname.setFocus();
        });
    }

    _removeCommentFromAttributes = (attributes) => {
        let attr = [];

        attributes.forEach((a) => {
            if (a.type !== 'comment') {
                attr.push(a);
            }
        });

        return attr;
    }

    _onConfigurationSelected = (config) => {
        this.setState({ config: config }, () => {
            this.entitytype.setValue(config.entitytype.id);
            this._onEntitytypeSelected(config.entitytype);
            this.header.setValue(config.header);
            this.clear.setValue(config.clear);
            this.append.setValue(config.append);

            if (config.folder) {
                this.folderselector.select(config.folder);
            } else {
                this.folderselector.selectFirst();
            }

            let relations = [];

            this.state.config.attributes.forEach((item) => {
                if (item.relation) {
                    for (let i = 0; i < this.state.relations.length; i++) {
                        let attr = [];

                        for (let j = 0; j < this.state.entitytypes.length; j++) {
                            if (this.state.entitytypes[j].id === this[`relentitytype${i}`].getItem().id) {
                                attr = this.state.entitytypes[j].attributes;
                                break;
                            }
                        }

                        relations.push({
                            column:     this[`relcolumn${i}`].getValue(),
                            entitytype: this[`relentitytype${i}`].getItem().id,
                            attribute:  this[`relattribute${i}`].getItem().id,
                            attributes: attr
                        });
                    }

                    let ent;

                    for (let k = 0; k < this.state.entitytypes.length; k++) {
                        if (this.state.entitytypes[k].id === item.relation.entitytype) {
                            ent = this.state.entitytypes[k];
                            break;
                        }
                    }

                    relations.push({
                        column:         item.column,
                        entitytype:     item.relation.entitytype,
                        attribute:      item.relation.attribute,
                        attributes:     this._removeCommentFromAttributes(ent.attributes)
                    });
                }
            });

            this.setState({ relations: relations }, () => {
                this.state.relations.forEach((item, index) => {
                    this[`relcolumn${index}`].setValue(item.column);
                    this[`relentitytype${index}`].setValue(item.entitytype);
                    this[`relattribute${index}`].setValue(item.attribute);
                });
            });
        });
    }

    _onEntitytypeSelected = (entitytype) => {
        let attr = [];

        entitytype.attributes.forEach((item) => {
            if (item.type !== 'comment') {
                attr.push({ id: item.id, name: item.name, column: null });
            }
        });

        let primarykey = null;

        if (this.state.config.entitytype.id === entitytype.id) {
            this.state.config.attributes.forEach((item) => {
                for (let i = 0; i < attr.length; i++) {
                    if (attr[i].id === item.id) {
                        attr[i].column = item.column;

                        if (item.primarykey) {
                            attr[i].primarykey = true;
                            primarykey = attr[i].id;
                        }
                    }
                }
            });
        }

        this.setState({ entitytype: entitytype, attributes: attr }, () => {
            attr.forEach((item) => {
                this['attr' + item.id].setValue(item.column || '');
            });
            this.primarykey.setValue(primarykey || attr[0].id);
        });
    }

    _onFolderSelected = (folder) => {
        this.setState({ folder: folder.path });
    }

    _toggleHeaderCheckbox = () => {
        this.header.toggle();
    }

    _toggleClearCheckbox = () => {
        this.clear.toggle();
    }

    _toggleAppendCheckbox = () => {
        this.append.toggle();
    }

    _cancel = () => {
        this.renameDialog.close();
    }

    _save = () => {

        // Validating

        if (this.configname.isEmpty()) {
            $.fireEvent('snackbar', { message: this.props.context.locale.importconfig.missingconfigname, error: true });
            return;
        }

        // Saving

        this.props.onLoading(true);

        let configuration = {
            name:           this.configname.getValue(),
            entitytype:     this.state.entitytype.id,
            header:         this.header.getValue(),
            clear:          this.clear.getValue(),
            append:         this.append.getValue(),
            folder:         this.state.folder,
            attributes:     []
        };

        if (this.configurationname.getItem().id !== 0) {
            configuration.id = this.configurationname.getItem().id;
        }

        this.state.entitytype.attributes.forEach((item) => {
            if (!this['attr' + item.id].isEmpty()) {
                let attr = { id: item.id, column: this['attr' + item.id].getValue() };

                if (this.primarykey.getItem().id === item.id) {
                    attr.primarykey = true;
                }

                for (let i = 0; i < this.state.relations.length; i++) {
                    if (this[`relcolumn${i}`].getValue() === attr.column) {
                        attr.relation = {
                            entitytype: this[`relentitytype${i}`].getItem().id,
                            attribute:  this[`relattribute${i}`].getItem().id
                        };
                        break;
                    }
                }

                configuration.attributes.push(attr);
            }
        });

        for (let i = 0; i < this.state.relations.length; i++) {
            let column = this[`relcolumn${i}`].getValue();
            let found = false;

            for (let j = 0; j < configuration.attributes.length; j++) {
                if (configuration.attributes[j].column === column) {
                    found = true;
                    break;
                }
            }

            if (!found) {
                configuration.attributes.push({ 
                    column: column, 
                    relation: {
                        entitytype: this[`relentitytype${i}`].getItem().id,
                        attribute:  this[`relattribute${i}`].getItem().id
                    }
                });
            }
        }

        Service.saveImportConfiguration(configuration).then(() => {

            // Hiding progress indicator

            this.renameDialog.close().then(() => {
                this.props.onLoading(false);

                this.componentDidMount();

                // Showing error
    
                $.fireEvent('snackbar', { message: this.props.context.locale.importconfig.savedmessage });                
            });
        }).catch((error) => {

            // Hiding progress indicator

            this.renameDialog.close().then(() => {
                this.props.onLoading(false);

                // Showing error

                $.fireEvent('snackbar', { message: this.props.context.locale.error.database, error: true });
            });
        });
    }

    _delete = () => {
        this.props.onLoading(true);
        
        Service.deleteImportConfiguration(this.configurationname.getItem().id).then(() => {

            // Hiding progress indicator

            this.props.onLoading(false);

            this.componentDidMount();

            // Showing confirm

            $.fireEvent('snackbar', { message: this.props.context.locale.importconfig.deletedmessage });                
        }).catch((error) => {

            // Hiding progress indicator

            this.props.onLoading(false);

            // Showing error

            $.fireEvent('snackbar', { message: this.props.context.locale.error.database, error: true });
        });
    }

    _onRelationEntitytypeSelected = (ind, entitytype) => {
        let relations = [];

        for (let i = 0; i < this.state.relations.length; i++) {
            let attr = [];

            for (let j = 0; j < this.state.entitytypes.length; j++) {
                if (this.state.entitytypes[j].id === this[`relentitytype${i}`].getItem().id) {
                    attr = this.state.entitytypes[j].attributes;
                    break;
                }
            }

            relations.push({
                column:     this[`relcolumn${i}`].getValue(),
                entitytype: this[`relentitytype${i}`].getItem().id,
                attribute:  this[`relattribute${i}`].getItem().id,
                attributes: this._removeCommentFromAttributes(attr)
            });
        }

        this.setState({ relations: relations }, () => {
            this.state.relations.forEach((item, index) => {
                this[`relcolumn${index}`].setValue(item.column);
                this[`relentitytype${index}`].setValue(item.entitytype);

                if (ind === index) {
                    this[`relattribute${index}`].setValue(item.attributes[0].id);
                } else {
                    this[`relattribute${index}`].setValue(item.attribute);
                }
            });
        });
    }

    _addRelation = () => {
        if (this.state.entitytypes.length === 0) {
            return;
        }
        
        let relations = [];

        for (let i = 0; i < this.state.relations.length; i++) {
            let attr = [];

            for (let j = 0; j < this.state.entitytypes.length; j++) {
                if (this.state.entitytypes[j].id === this[`relentitytype${i}`].getItem().id) {
                    attr = this.state.entitytypes[j].attributes;
                    break;
                }
            }

            relations.push({
                column:     this[`relcolumn${i}`].getValue(),
                entitytype: this[`relentitytype${i}`].getItem().id,
                attribute:  this[`relattribute${i}`].getItem().id,
                attributes: attr
            });
        }

        relations.push({
            column:         1,
            entitytype:     this.state.entitytypes[0].id,
            attribute:      this.state.entitytypes[0].attributes[0].id,
            attributes:     this._removeCommentFromAttributes(this.state.entitytypes[0].attributes)
        });

        this.setState({ relations: relations }, () => {
            this.state.relations.forEach((item, index) => {
                this[`relcolumn${index}`].setValue(item.column);
                this[`relentitytype${index}`].setValue(item.entitytype);
                this[`relattribute${index}`].setValue(item.attribute);
            });
        });
    }

    _removeRelation = (index) => {
        let relations = [];

        for (let i = 0; i < this.state.relations.length; i++) {
            let attr = [];

            for (let j = 0; j < this.state.entitytypes.length; j++) {
                if (this.state.entitytypes[j].id === this[`relentitytype${i}`].getItem().id) {
                    attr = this.state.entitytypes[j].attributes;
                    break;
                }
            }

            relations.push({
                column:     this[`relcolumn${i}`].getValue(),
                entitytype: this[`relentitytype${i}`].getItem().id,
                attribute:  this[`relattribute${i}`].getItem().id,
                attributes: this._removeCommentFromAttributes(attr)
            });
        }

        relations.splice(index, 1);

        this.setState({ relations: relations }, () => {
            this.state.relations.forEach((item, index) => {
                this[`relcolumn${index}`].setValue(item.column);
                this[`relentitytype${index}`].setValue(item.entitytype);
                this[`relattribute${index}`].setValue(item.attribute);
            });
        });
    }

    /** 
     * Event that fires when the screen mounted.
     */

    componentDidMount() {

        // Setting actionbar title

        this.props.onSetActionbarTitle(this.props.context.locale.importconfig.title);

        // Showing progress indicator

        this.props.onLoading(true);

        // Loading the entity types

        Service.loadEntitytype().then((entitytypes) => {

            // Storing the entity types

            this.setState({ entitytypes: entitytypes });

            // Loading the import configurations

            if (entitytypes.length > 0) {
                Service.loadImportConfiguration().then((configurations) => {
                    let attr = [];
                    
                    entitytypes[0].attributes.forEach((item) => {
                        attr.push({ id: item.id, name: item.name, column: null });
                    });

                    configurations.push({
                        id:             0,
                        name:           this.props.context.locale.importconfig.newconfiguration,
                        entitytype:     entitytypes[0],
                        header:         true,
                        clear:          false,
                        append:         true,
                        folder:         null,
                        attributes:     attr,
                        primarykey:     entitytypes[0].attributes[0].id
                    });

                    // Storing the import configurations

                    this.setState({ configurations: configurations, attributes: attr, entitytype: configurations[configurations.length - 1].entitytype }, () => {
                        this.configurationname.setValue(0);
                        this._onConfigurationSelected(configurations[configurations.length - 1]);
                    });

                    // Refreshing the folder tree

                    this.folderselector.load().then(() => {

                        this.folderselector.selectFirst();
                        
                        // Hiding progress indicator

                        this.props.onLoading(false);
                    });
                }).catch((error) => {

                    // Hiding the progress indicator

                    this.props.onLoading(false);

                    // Showing error

                    $.fireEvent('snackbar', { message: this.props.context.locale.error.database, error: true });
                });
            } else {

                // Hiding progress indicator

                this.props.onLoading(false);                
            }
        }).catch((error) => {

            // Hiding the progress indicator

            this.props.onLoading(false);

            // Showing error

            $.fireEvent('snackbar', { message: this.props.context.locale.error.database, error: true });
        });
    }

    /** 
     * Import screen renderer.
     */

    render() {
        return (
            <div className="importconfig">

                {/* Import container */}

                <div className="importconfig-container" style={{ height: (this.props.context.environment.screen.usefullheight - 72) + 'px'}}>
                    <Combobox ref={c => {this.configurationname = c;}} tooltip={this.props.context.locale.importconfig.configurationname.tooltip} width={230} label={this.props.context.locale.importconfig.configurationname.label} labelwidth={120} labelposition="left" idattr="id" nameattr="name" source={this.state.configurations} onSelect={this._onConfigurationSelected} />
                    <Combobox ref={c => {this.entitytype = c;}} topgap={32} tooltip={this.props.context.locale.importconfig.entitytype.tooltip} width={230} label={this.props.context.locale.importconfig.entitytype.label} labelwidth={120} labelposition="left" idattr="id" nameattr="name" source={this.state.entitytypes} onSelect={this._onEntitytypeSelected} />
                    
                    {/* Header */}

                    <div className="horizontal" title={this.props.context.locale.importconfig.header.tooltip}>
                        <Label text={this.props.context.locale.importconfig.header.label} width={120} onTouch={this._toggleHeaderCheckbox} />
                        <Checkbox ref={c => {this.header = c}} />
                    </div>

                    {/* Clear */}

                    <div className="horizontal" title={this.props.context.locale.importconfig.clear.tooltip}>
                        <Label text={this.props.context.locale.importconfig.clear.label} width={120} topgap={16} onTouch={this._toggleClearCheckbox} />
                        <Checkbox ref={c => {this.clear = c}} topgap={16} />
                    </div>

                    {/* Append */}

                    <div className="horizontal" title={this.props.context.locale.importconfig.append.tooltip}>
                        <Label text={this.props.context.locale.importconfig.append.label} width={120} topgap={16} onTouch={this._toggleAppendCheckbox} />
                        <Checkbox ref={c => {this.append = c}} topgap={16} />
                    </div>

                    {/* Folder */}

                    <Section label={this.props.context.locale.importconfig.folder.label} title={this.props.context.locale.importconfig.folder.tooltip} topgap={16} />
                    <Folderselector ref={c => {this.folderselector = c;}} context={this.props.context} onSelect={this._onFolderSelected} onLoading={this.props.onLoading} />

                    {/* Attributes */}

                    <Section label={this.props.context.locale.importconfig.attribute.label} title={this.props.context.locale.importconfig.attribute.tooltip} topgap={16} bottomgap={2} />

                    <Combobox ref={c => {this.primarykey = c;}} tooltip={this.props.context.locale.importconfig.primarykey.tooltip} width={172} bottomgap={16} label={this.props.context.locale.importconfig.primarykey.label} labelwidth={180} labelposition="left" idattr="id" nameattr="name" source={this.state.attributes} />

                    { this.state.config && this.state.attributes.map((item, index) =>
                        item.type !== 'comment' && <Numericbox ref={c => {this['attr' + item.id] = c;}} key={index} label={`${item.name}:`} labelwidth={180} labelposition="left" width={20} />
                    )}

                    {/* Relations */}

                    <Section label={this.props.context.locale.importconfig.relation.label} title={this.props.context.locale.importconfig.relation.tooltip} topgap={16} bottomgap={2} />

                    <div className="horizontal importconfig-relationcolumns">
                        <Label text={this.props.context.locale.importconfig.relation.column} width={56} />
                        <Label text={this.props.context.locale.importconfig.relation.entitytype} width={160} />
                        <Label text={this.props.context.locale.importconfig.relation.attribute} width={128} />
                    </div>

                    { this.state.config && this.state.relations.map((item, index) =>
                        <div key={index} className="horizontal">
                            <Numericbox ref={c => {this['relcolumn' + index] = c;}} width={20} />
                            <Combobox ref={c => {this['relentitytype' + index] = c;}} leftgap={8} tooltip={this.props.context.locale.importconfig.relation.entitytype} width={120} idattr="id" nameattr="name" source={this.state.entitytypes} onSelect={this._onRelationEntitytypeSelected.bind(this, index)} />
                            <Combobox ref={c => {this['relattribute' + index] = c;}} leftgap={8} tooltip={this.props.context.locale.importconfig.relation.attribute} width={120} idattr="id" nameattr="name" source={item.attributes} />
                            <img alt="Delete relation" src={DeleteIcon} className="importconfig-delete-icon" title={this.props.context.locale.importconfig.relation.buttons.remove} onClick={this._removeRelation.bind(this, index)} />
                        </div>
                    )}

                    <Fab icon={AddIcon} topgap={16} tooltip={this.props.context.locale.importconfig.relation.buttons.add} onTouch={this._addRelation} />
                </div>

                <div className="importconfig-buttons horizontal">
                    <div className="flex"></div>
                    { this.state.config && this.state.config.id !== 0 && <Button label={this.props.context.locale.importconfig.buttons.delete.label} tooltip={this.props.context.locale.importconfig.buttons.delete.label} width={60} onTouch={this._delete} /> }
                    <Button label={this.props.context.locale.importconfig.buttons.save.label} tooltip={this.props.context.locale.importconfig.buttons.save.label} leftgap={16} rightgap={16} width={60} disabled={this.state.entitytypes.length === 0} onTouch={this._rename} />
                </div>

                {/* Snackbar */}

                <Snackbar ref={c => {this.snackbar = c;}} />

                {/* Delete confirm dialog */}

                <Dialog ref={c => {this.renameDialog = c;}} width={360} height={124} closetooltip={this.props.context.locale.importconfig.renamedialog.close}>

                    {/* Message */}

                    <div className="importconfig-renamedialog-title">{this.props.context.locale.importconfig.renamedialog.message}</div>

                    <Textbox ref={c => {this.configname = c;}} topgap={16} label={this.props.context.locale.importconfig.renamedialog.name} tooltip={this.props.context.locale.importconfig.renamedialog.message} labelwidth={60} labelposition="left" width={272} />

                    {/* Buttons */}

                    <div className="horizontal">

                        {/* Spacer */}

                        <div className="flex"></div>

                        {/* Save */}

                        <Button label={this.props.context.locale.importconfig.renamedialog.buttons.save.label} tooltip={this.props.context.locale.importconfig.renamedialog.buttons.save.tooltip} width={60} onTouch={this._save} />

                        {/* Cancel */}

                        <Button label={this.props.context.locale.importconfig.renamedialog.buttons.cancel.label} tooltip={this.props.context.locale.importconfig.renamedialog.buttons.cancel.tooltip} width={60} leftgap={8} onTouch={this._cancel} />
                    </div>
                </Dialog>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/Screens/Importconfig/Importconfig.js